<template>
  <div :class="'review p-3 ' + topic">
    <div class="w-100">
      <span class="float-right"><a :href="url">{{ date }}</a></span>
      <span class="author">{{ author }}</span><span v-if="country">&nbsp;from {{ country }}</span>
    </div>
    <blockquote><slot></slot></blockquote>
  </div>
</template>

<script>
export default {
  name: "Review",
  props: {
    author: String,
    country: String,
    date: String,
    source: String,
    topic: String,
    url: String,
    width: Number
  }
}

</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

.author {
  font-weight: bold;
  padding-top: 1ex;
}
blockquote {
  border-left: solid $gp-dark-brand 20px;
  padding-left: 1em;
  margin-top: 1ex;
  color: $gray;
}
.review {
  display: none;
  min-height: 20ex;
  font-size: smaller;
  border-radius: 5px;
  color: $gp-dark-brand;

  &.active {
    display: block;
    min-height: 20ex;
  }
}

</style>
